export default {"src":"/_next/static/media/near-protocol-near-logo.3ee3ef11.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};